<template>
  <div id="app">
    <Navbar/>
    <router-view/>
    <AppFooter/>
  </div>
</template>

<script>
import Nav from '@/components/Navbar.vue'
import AppFooter from '@/components/Footer.vue'

export default {
  name: 'App',
  components: {
    Navbar: Nav,
    AppFooter
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  background-color: #000000;
}
</style>
